// extracted by mini-css-extract-plugin
export default {"Btn":"QuantityBtn_Btn__TKhNo","display":"QuantityBtn_display__vrDot","text":"QuantityBtn_text__9Iuvu"};